module.exports = __webpack_public_path__ + "static/media/repl.4bfedead.svg";